import React, { FC } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { bp, layer, palette, sizes } from 'entity/createTheme';

type Props = {
  isOpen: boolean;
  className?: string;
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const QuestionContentModal: FC<Props> = ({ className, children, isOpen }) => {
  return (
    <>
      {isOpen && <ModalBackground />}
      <Root className={className} open={isOpen}>
        <ContentWrapper>
          <Content>{children}</Content>
        </ContentWrapper>
      </Root>
    </>
  );
};

const ModalBackground = styled('div')({
  position: 'fixed',
  height: '100vh',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: layer.topUnder1,
  background: 'rgba(0, 0, 0, 0.6)',
  animation: `${fadeIn} 0.35s linear`,
});

const Root = styled('div')<{ open: boolean }>(props => ({
  position: 'fixed',
  height: '100vh',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: layer.topUnder1,
  visibility: props.open ? 'visible' : 'hidden',
  opacity: props.open ? 1 : 0,
  display: 'flex',
  justifyContent: 'center',
  transform: props.open ? 'translateX(0)' : 'translateX(25%)',
  transition: '0.5s ease',
}));

const ContentWrapper = styled('div')({
  position: 'relative',
  width: '100%',
  maxWidth: 1440,
  paddingLeft: sizes.sizebarWidth,
  height: '100%',
  [`@media ${bp.sm}`]: {
    paddingLeft: 0,
  },
});

const Content = styled('div')({
  width: '100%',
  height: '100vh',
  padding: 30,
  background: palette.grayMedium5,
  overflowY: 'auto',
});

export default QuestionContentModal;
